import {
    getBridgeSdk,
    clearAuthHeadersFromStorage,
    GlobalHeaderState,
    SwgyHeaderKeysList,
    CleanupSource,
    cleanupPersistOrderDataInLocalStorage,
} from "@swiggy-private/checkout-core";
import { RawOrderData } from "@swiggy-private/payment-types";
import { clearWebviewRefreshSavedState } from "./Misc";
import { isAndroidPlatform } from "@payment-client/utils/Headers";

export function postOrderEventHelper(orderData: RawOrderData, clearHeaders: boolean): void {
    if (clearHeaders) {
        clearAuthHeadersFromStorage();
    }

    const platform = GlobalHeaderState.getHeader(SwgyHeaderKeysList.platform);

    try {
        cleanupPersistOrderDataInLocalStorage(CleanupSource.CONFIRM_ORDER_SUCCESS);
    } catch {
        // no-op
    }

    if (isAndroidPlatform(platform)) {
        // used to clear webview refresh state in app memory after payment failures
        clearWebviewRefreshSavedState();
    }

    getBridgeSdk()
        .postOrderEvent(orderData)
        .catch(() => void 0);
}
